import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AppConfig } from '../../app.config';
import { ContactUsDialogComponent } from '../contact-us-dialog/contact-us-dialog.component';

@Component({
  selector: 'Teranet-Footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit, OnDestroy {

  destroy$: Subject<boolean> = new Subject<boolean>();
  currentversion: string;

  constructor(public dialog: MatDialog, private router: Router) { }

  ngOnInit() {
    this.currentversion = AppConfig.settings.settings.Dashboard_Version;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ContactUsDialogComponent);
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

}
